 var comment_slider =  $('.fa-comment-row').owlCarousel({
      loop:true,
      margin:10,
      nav:false,
      dots: false,
      responsive:{
          0:{
              items:1,
          },
          560:{
              items:2,
          },
          900:{
              items:3
          },
          1230:{
              items:4
          }
      }
  });
$('.ip-next-comment').click(function() {
    comment_slider.trigger('next.owl.carousel');
});

$('.ip-prev-comment').click(function() {
    comment_slider.trigger('prev.owl.carousel');
});

 var collection_slider =  $('.ip-collectionslider-row').owlCarousel({
      loop:true,
      margin:10,
      nav:true,
      dots: false,
      responsive:{
          0:{
              items:1,
          },
          560:{
              items:2,
          },
          900:{
              items:3
          },
          1230:{
              items:4
          }
      }
  });

 var banner_slider =  $('.ip-banner-slider-row').owlCarousel({
      loop:true,
      margin:10,
      nav:false,
      dots: true,
      responsive:{
          0:{
              items:1,
          },
          560:{
              items:1,
          },
          900:{
              items:1
          },
          1230:{
              items:1
          }
      }
  });


 var products_slider =  $('.ip-productslider-row').owlCarousel({
      loop:true,
      margin:10,
      nav:true, 
      dots: false,
      responsive:{
          0:{
              items:1,
          },
          560:{
              items:2,
          },
          900:{
              items:3
          },
          1230:{
              items:4
          }
      }
  });

 var products_slider_tabs =  $('.ip-productslider-tab-row').owlCarousel({
      loop:true,
      margin:10,
      nav:true, 
      dots: false,
      responsive:{
          0:{
              items:1,
          },
          560:{
              items:2,
          },
          900:{
              items:3
          },
          1230:{
              items:4
          }
      }
  });


 var products_slider_related =  $('.ip-related-productslider-row').owlCarousel({
      loop:true,
      margin:10,
      nav:true, 
      dots: false,
      responsive:{
          0:{
              items:1,
          },
          560:{
              items:2,
          },
          900:{
              items:3
          },
          1230:{
              items:4
          }
      }
  });



document.addEventListener('DOMContentLoaded', function () {
  function initOwlCarousel(container = document) {
    const $carousels = $(container).find('.owl-carousel');

    $carousels.each(function () {
      const $this = $(this);
      if (!$this.hasClass('owl-loaded')) {
        $this.owlCarousel({
          loop: true,
          margin: 10,
          nav: true,
          dots: true,
          responsive: {
            0:{
              items:1,
          },
          560:{
              items:2,
          },
          900:{
              items:3
          },
          1230:{
              items:4
          }
          }
        });
        
      }
    });
  }
  // const interval = setInterval(() => {
  //   console.log("Recomended Products Loaded");
  //   const container = document.querySelector('product-recommendations .owl-carousel');
  //   if (container && container.children.length > 0) {
  //     initOwlCarousel(container.closest('product-recommendations'));
  //   }
  //   if(container.classList.contains('owl-loaded')){
  //     clearInterval(interval);
  //   }
  // }, 300); 
  const interval = setInterval(() => {
  console.log("Recommended Products Loaded");
  const container = document.querySelector('product-recommendations .owl-carousel');

  if (container && container.children.length > 0) {
    initOwlCarousel(container.closest('product-recommendations'));

    if (container.classList.contains('owl-loaded')) {
      clearInterval(interval);
    }
  }
}, 300);
});
